<mat-form-field [formGroup]="paramsGroup">
  <mat-label>Choose a date</mat-label>
  <input matInput formControlName="value" placeholder="YYYY-MM-DD" [matDatepicker]="picker" />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  @if (paramsGroup.get('value')?.hasError('required')) {
    <mat-error>This field is required</mat-error>
  }
</mat-form-field>
